import { render, staticRenderFns } from "./PublicPillars.vue?vue&type=template&id=6a2c72c5&scoped=true&"
import script from "./PublicPillars.vue?vue&type=script&lang=js&"
export * from "./PublicPillars.vue?vue&type=script&lang=js&"
import style0 from "./PublicPillars.vue?vue&type=style&index=0&id=6a2c72c5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c72c5",
  null
  
)

export default component.exports